<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-06-27 15:12:46
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-06 11:25:36
 * @FilePath: \合联\oms\src\view\costRule\deliveryCostQuoteRule\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/priceRule/storageFeeQuoteRule";
export default {
  name: "storageCostQuoteRule",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                id: row.id,
                continued: this.list,
              });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1000,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              quantity: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              volume: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              scheme: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              system: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
            },
          },
          grid: [
            {
              title: 12,
              client_id: 12,
              currency: 12,
              quantity: 12,
              volume: 12,
              scheme: 12,
              system: 12,
              remarks: 24,
            },
          ],
          fields: [
            {
              name: () => this.$tz("标题"),
              key: "title",
              component: "Input",
              placeholder: () => this.$tz("标题"),
            },
            {
              name: this.$tz("客户名称"),
              key: "client_id",
              component: "Select",
              placeholder: () => this.$tz("客户名称"),
              options: [],
              optionsFn: "getAllClient",
              optionsKey: "",
              default: "",
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
            },
            {
              name: () => this.$tz("库位,个数,单价,(,月,)"),
              key: "quantity",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("库位,体积,单价,(,月,)"),
              key: "volume",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("方案,上架,单价,(,天,)"),
              key: "scheme",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("系统,上架,单价,(,天,)"),
              key: "system",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户名称");
            },
            component: "Select",
            options: [],
            optionsFn: "getAllClient",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
              id: 1784,
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$tz("标题"),
          key: "title",
          minWidth: 110,
        },
        {
          name: () => this.$tz("客户名称"),
          key: "client_name",
          minWidth: 110,
        },
        {
          name: () => this.$t("currency_t"),
          key: "currency",
          minWidth: 130,
        },
        {
          name: () => this.$tz("库位,个数,单价,(,月,)"),
          key: "quantity",
          minWidth: 110,
        },
        {
          name: () => this.$tz("库位,体积,单价,(,月,)"),
          key: "volume",
          minWidth: 110,
        },
        {
          name: () => this.$tz("方案,上架,单价,(,天,)"),
          key: "scheme",
          minWidth: 110,
        },
        {
          name: () => this.$tz("系统,上架,单价,(,天,)"),
          key: "system",
          minWidth: 110,
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
              id: 1784,
            },
            {
              name: () => this.$tz("删除"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              id: 1783,
            },
          ],
          methods: {
            update({ row }) {
              this.getModal("add").open(row, function () {
                this.list = row.continued;
                this.setTitle(this.$tz("编辑"));
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>